module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4VGZV"))).then(() => parcelRequire('hEqeo'));